import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import SalesRepDashboard from "./screens/sales_rep/SalesRepDashboard"
import { useContext, useEffect, useState } from "react"
import SalesRepNav from "./components/sales_rep/SalesRepNav"
import Header from "./components/Header"
// import SalesRepSettings from "./screens/sales_rep/SalesRepSettings"
import SalesRepSales from "./screens/sales_rep/SalesRepSales"
import { AppContext } from "./context/AppContext"
import Settings from "./screens/Settings"

const SalesRep = () => {

    const { loggedIn, setLoggedIn } = useContext(AppContext)

    const location = useLocation()
    const Navigate = useNavigate()

    const [headerTitle, setHeaderTitle] = useState('')
    const [expandedNav, setExpandedNav] = useState(false)

    const handleTitleChange = () => {
        switch (location.pathname) {
            case '/sales_rep/dashboard':
                setHeaderTitle('Dashboard')
                break;

            case '/sales_rep/sales':
                setHeaderTitle('Sales')
                break;

            case '/sales_rep/settings':
                setHeaderTitle('Settings')
                break;

            default:
                setHeaderTitle('Sales Rep')
                break;
        }
    }

    useEffect(() => {
        if (!loggedIn) {
            Navigate('/login')
        }
    }, [loggedIn, Navigate])

    useEffect(() => {
        handleTitleChange()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    return (
        <div className=" w-full h-screen md:flex relative">
            <SalesRepNav expandedNav={expandedNav} setExpandedNav={setExpandedNav} />

            <div onClick={() => setExpandedNav(false)} className={`${expandedNav ? " block" : " hidden"} md:hidden fixed w-screen h-screen z-10`}></div>

            <div className=" h-full overflow-y-auto overflow-x-hidden md:flex-1 scrollbar relative">
                <Header setExpandedNav={setExpandedNav} title={headerTitle} setLoggedIn={setLoggedIn} />
                <Routes>
                    <Route element={<SalesRepDashboard />} path="/dashboard" />
                    <Route element={<SalesRepSales />} path="/sales" />
                    {/* <Route element={<SalesRepSettings />} path="/settings" /> */}
                    <Route element={<Settings userType={'Sales Rep'} />} path="/settings" />
                </Routes>
            </div>
        </div>
    )
}

export default SalesRep